const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  toggleAddressButtonEdit: 'button[aria-edit]',
  cancelAddressButton: '#AddAddress button[type="reset"]',
  cancelEditAddressButton: '[data-list-addresses] button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
  toggleSidebar: '.account-header',
  listAddresses: '[data-list-addresses]',
  titleAddress: '.js-title-address'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
  edit: 'aria-edit'
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
      listAddresses: document.querySelector(selectors.listAddresses),
      titleAddress: document.querySelector(selectors.titleAddress),
      toggleButtonEdits: document.querySelectorAll(selectors.toggleAddressButtonEdit),
      cancelEditButtons: document.querySelectorAll(selectors.cancelEditAddressButton)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
    this.elements.toggleButtonEdits.forEach(toggleButtonEdit => {
      toggleButtonEdit.addEventListener('click', this._handleAddEditAddressClick); 
    });
    this.elements.cancelEditButtons.forEach(cancelEditButton => {
      cancelEditButton.addEventListener('click', () => {
        console.log(cancelEditButton.getAttribute('data-item'));
        this.elements.toggleButtonEdits.forEach( toggleButtonEdit => {
          console.log(toggleButtonEdit.getAttribute('data-item'));
          if (cancelEditButton.getAttribute('data-item') == toggleButtonEdit.getAttribute('data-item') ) {
            toggleButtonEdit.setAttribute('aria-edit', 'false');
          }
        });
      });  
    });    
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
    this.elements.listAddresses.classList.toggle('hidden');
    target.classList.add('hidden');
    this.elements.titleAddress.classList.add('hidden');
  }

  _toggleExpandedEdit(target) {
    target.setAttribute(
      attributes.edit,
      (target.getAttribute(attributes.edit) === 'false').toString()
    );
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleAddEditAddressClick = ({ currentTarget }) => {
    this._toggleExpandedEdit(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
    this.elements.titleAddress.classList.remove('hidden');
    this.elements.toggleButtons.forEach((element) => {
      element.classList.remove('hidden');
    });
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}

class toggleSidebar {
  constructor() {
    this.element = this._getElements();
    this._setupEventListeners();
  }

  _getElements() {
    const elm = document.querySelector(selectors.toggleSidebar);
    return elm;
  }

  _setupEventListeners() {
    this.element.addEventListener('click', this._toggleSidebar);
  }

  _toggleSidebar(){
    document.querySelector(selectors.toggleSidebar).classList.toggle('show-full');
    console.log(12345);
  }
}
 

